import {Form, Input, DatePicker, Row, Col, InputNumber, Select} from 'antd';
import React, {useContext, useEffect} from 'react';
import WangEditor from "../common/WangEditor";
import {sideMenuContext} from "../../../router/IndexRouter";
import AddFormComponent from "../common/AddFormComponent";
import EditFormComponent from "../common/EditFormComponent";
import {Arguments} from "../common/Arguments";
import SaveButtonComponent from "../common/SaveButtonComponent";
import {validateEditorContent, validateWhiteSpace} from "../common/ValidateWhiteSpace";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};

const tailLayout = {
    wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef();

const AddPartyActivity = () => {
    const currentUrl = window.location.href;
    // 获取 WangEditor 中的数据
    const {editorContent} = useContext(sideMenuContext);
    const apiList = [Arguments.host + "/society_organization/base/branch/api!addPartyActivity.do"];

    useEffect(() => {
        formRef.current.setFieldsValue({
            activityMemo: editorContent
        });
    }, [editorContent])

    return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={PartyActivityForm} url={apiList}/>
        : <EditFormComponent UserForm={PartyActivityForm} url={apiList}/>)
}

const PartyActivityForm = ({onFinish, initialValues}) => {
    const [form] = Form.useForm();

    return (
        <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={onFinish}
            initialValues={initialValues}
            style={{maxWidth: 1200, marginLeft: 40}}
            ref={formRef}
        >
            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityName" label="活动主题" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={12}>
                    <Form.Item name="activityDate" label="活动时间" rules={[{required: true, message: '内容不能为空'}]}>
                        <DatePicker placeholder="选择日期"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="activityScope" label="参加人数" rules={[{required: true, message: '内容不能为空'}]}
                               initialValue={0}>
                        <InputNumber min={0} style={{width: 150}}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityAddress" label="活动地址" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityForm" label="活动形式" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={12}>
                    <Form.Item name="activityApplyMoney" label="申请经费">
                        <Input/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="activityApprovalMoney" label="审批经费">
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={12}>
                    <Form.Item name="checkStatus" label="审核状态" rules={[{required: true, message: '内容不能为空'}]}
                               initialValue="未审">
                        <Select disabled={true}>
                            <Select.Option value="通过">通过</Select.Option>
                            <Select.Option value="驳回">驳回</Select.Option>
                            <Select.Option value="未审">未审</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="activityCompere" label="主持人"
                               rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityMemo" label="活动说明" rules={[{required: true, validator: validateEditorContent}]}>
                        <WangEditor defaultValue={initialValues?.activityMemo}
                                    placehoderText="请在此填写活动计划内容！活动结束后请上传活动现场照片以及相应文字材料！"/>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item {...tailLayout}>
                <SaveButtonComponent/>
            </Form.Item>
        </Form>
    );
};

export default AddPartyActivity;
